import { alpha, createTheme } from '@mui/material/styles';
export const smartHomePalette = {
    background: {
        default: '#070b14',
        paper: '#101826',
        elevated: '#182235',
        panel: '#121b2a',
        lightDefault: '#f3f6fb',
        lightPaper: '#ffffff'
    },
    text: {
        primary: '#f5f7fb',
        secondary: '#97a2b8',
        lightPrimary: '#101826',
        lightSecondary: '#5d6a82'
    },
    accent: {
        primary: '#63e6be',
        info: '#70a5ff',
        warning: '#ffb65c',
        danger: '#ff6b8b'
    },
    border: 'rgba(151, 162, 184, 0.16)'
};
export const dashboardGradients = {
    hero: 'linear-gradient(135deg, rgba(99,230,190,0.16) 0%, rgba(112,165,255,0.22) 50%, rgba(255,107,139,0.12) 100%)',
    panel: 'linear-gradient(180deg, rgba(24,34,53,0.92) 0%, rgba(14,20,34,0.96) 100%)'
};
export const smartHomeShadows = {
    panel: '0 20px 60px rgba(5, 10, 24, 0.42)',
    glow: '0 0 0 1px rgba(99,230,190,0.1), 0 18px 48px rgba(10, 20, 40, 0.45)'
};
export const createSmartHomeTheme = (mode = 'dark') => createTheme({
    palette: {
        mode,
        primary: { main: smartHomePalette.accent.primary },
        secondary: { main: smartHomePalette.accent.info },
        warning: { main: smartHomePalette.accent.warning },
        error: { main: smartHomePalette.accent.danger },
        background: {
            default: mode === 'dark' ? smartHomePalette.background.default : smartHomePalette.background.lightDefault,
            paper: mode === 'dark' ? smartHomePalette.background.paper : smartHomePalette.background.lightPaper
        },
        text: {
            primary: mode === 'dark' ? smartHomePalette.text.primary : smartHomePalette.text.lightPrimary,
            secondary: mode === 'dark' ? smartHomePalette.text.secondary : smartHomePalette.text.lightSecondary
        },
        divider: smartHomePalette.border
    },
    shape: {
        borderRadius: 24
    },
    typography: {
        fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 700 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: mode === 'dark'
                        ? `radial-gradient(circle at top, ${alpha('#70a5ff', 0.12)} 0%, transparent 28%), ${smartHomePalette.background.default}`
                        : smartHomePalette.background.lightDefault,
                    minHeight: '100vh'
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: mode === 'dark' ? dashboardGradients.panel : 'none',
                    backgroundColor: mode === 'dark' ? undefined : '#ffffff',
                    border: `1px solid ${smartHomePalette.border}`,
                    boxShadow: smartHomeShadows.panel,
                    backdropFilter: 'blur(18px)'
                }
            }
        },
        MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
        MuiButton: { styleOverrides: { root: { borderRadius: 16, paddingInline: 18 } } },
        MuiChip: { styleOverrides: { root: { borderRadius: 999 } } }
    }
});
